var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220.113,
    height: 110.038,
    viewBox: "0 0 220.113 110.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.65 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M188.206,73.2,122.96,70.165,239.783,62.31l54.086,3.166L194.331,72.76",
    transform: "translate(-80.501 -62.31)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M122.96,119.048V71.39l65.246,2.6v90.17l-16.082-2.941",
    transform: "translate(-80.501 -63.535)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_234",
    "data-name": "Line 234",
    x1: 8.374,
    y1: 1.531,
    transform: "translate(55.86 91.156)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M216.461,158.558l-18.081,4.525V71.495l5.381-.536.061,2.016,101.018-7.44V63.622l4.049-.242-.009,72.072L222.2,157.131",
    transform: "translate(-90.675 -62.454)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M126.34,119.656V76.41l59.649,3.46v74.373l-49.095-7.734",
    transform: "translate(-80.957 -64.212)",
    fill: "#878c96",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M199.52,80.9l4.992-.372v1.436",
    transform: "translate(-90.829 -64.768)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M198.38,82.19l23.436,2.189-.112,78.3L198.38,156.26Z",
    transform: "translate(-90.675 -64.992)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_235",
    "data-name": "Line 235",
    y2: 3.729,
    transform: "translate(126.27 14.776)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_236",
    "data-name": "Line 236",
    y2: 2.863,
    transform: "translate(119.427 15.243)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_237",
    "data-name": "Line 237",
    y2: 2.768,
    transform: "translate(126.426 96.511)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M198.38,94.4l20.114,2.4v5.961l-20.114-2.639Z",
    transform: "translate(-90.675 -66.639)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M198.38,121.49l20.114,3.3v5.961l-20.114-3.53Z",
    transform: "translate(-90.675 -70.293)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M198.38,150.62l20.114,5.078v5.961l-20.114-5.3Z",
    transform: "translate(-90.675 -74.223)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_238",
    "data-name": "Line 238",
    x2: 1.938,
    transform: "translate(105.041 22.043)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_239",
    "data-name": "Line 239",
    x2: 1.938,
    transform: "translate(105.041 42.433)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_240",
    "data-name": "Line 240",
    x2: 1.938,
    transform: "translate(105.041 65.376)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_241",
    "data-name": "Line 241",
    x2: 1.938,
    transform: "translate(105.041 85.472)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M225.853,154.517l3.331-.8V78.31l-4.784.415v5.044",
    transform: "translate(-94.185 -64.468)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M236.1,152.277l4.533-1.1V77.29L236.1,77.7Z",
    transform: "translate(-95.763 -64.331)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M248.38,149.567l4.282-1.038V76.25l-4.282.372Z",
    transform: "translate(-97.42 -64.19)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M260.65,146.848l4.04-.978V75.2l-4.04.355Z",
    transform: "translate(-99.075 -64.049)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M272.64,144.2l3.8-.917V74.18l-3.8.329Z",
    transform: "translate(-100.692 -63.911)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M284.35,141.627l3.547-.874V73.18l-3.547.311Z",
    transform: "translate(-102.272 -63.776)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M295.48,139.168l3.3-.8V72.33l-3.3.285Z",
    transform: "translate(-103.773 -63.662)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M306.04,136.845l3.054-.779V71.53l-3.054.268Z",
    transform: "translate(-105.198 -63.554)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M316.32,134.587l2.8-.683V70.76l-2.8.242Z",
    transform: "translate(-106.585 -63.45)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_245",
    "data-name": "Ellipse 245",
    cx: 0.45,
    cy: 1.09,
    rx: 0.45,
    ry: 1.09,
    transform: "translate(110.015 11.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M116.9,119.829V76.41L78.03,77.465V123.16",
    transform: "translate(-74.44 -64.212)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M82.07,94.787l31.611-.493V88.93l-31.611.493Z",
    transform: "translate(-74.985 -65.901)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M82.1,117.5l31.585-.5V111.64l-31.585.493Z",
    transform: "translate(-74.989 -68.965)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_242",
    "data-name": "Line 242",
    x2: 0.147,
    y2: 43.714,
    transform: "translate(49.319 12.397)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_243",
    "data-name": "Line 243",
    y2: 3.331,
    transform: "translate(24.707 9.179)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_244",
    "data-name": "Line 244",
    y2: 3.434,
    transform: "translate(11.644 9.473)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_245",
    "data-name": "Line 245",
    y1: 0.242,
    x2: 2.924,
    transform: "translate(42.459 17.337)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_246",
    "data-name": "Line 246",
    y1: 0.242,
    x2: 2.924,
    transform: "translate(42.459 36.118)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M174.47,151.63v1.895l17.5-2.656V149Z",
    transform: "translate(-87.449 -74.004)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M178.173,153.58V157.7l-3.7.571v-4.127Z",
    transform: "translate(-87.449 -74.622)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M188.53,156.153V152.1l3.806-.675v3.806Z",
    transform: "translate(-89.346 -74.332)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M170.5,153.407,145.05,149.7V148.13l25.451,3.383Z",
    transform: "translate(-83.481 -73.887)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M173.887,154.157v4.127l-3.737-.363v-4.23Z",
    transform: "translate(-86.867 -74.637)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M160.133,152.14v4.351l-3.443-.6V151.63Z",
    transform: "translate(-85.051 -74.359)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M165.558,152.929v2.812l-4.888.831V152.22Z",
    transform: "translate(-85.588 -74.439)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M145.05,149.94v4.144l3.149.32V150.4Z",
    transform: "translate(-83.481 -74.131)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M152.419,151.24v2.483l-3.729.753V150.47Z",
    transform: "translate(-83.972 -74.203)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M172.608,150.063V138.687l-11.938-1.5v11.264Z",
    transform: "translate(-85.588 -72.411)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M168.4,138.16v3.5l-2.076-.234V137.9",
    transform: "translate(-86.35 -72.507)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M174.47,138.621l13.305-1.921v11.255L174.47,150Z",
    transform: "translate(-87.449 -72.345)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M160.67,135.39V123.85l11.938,1.3v11.739Z",
    transform: "translate(-85.588 -70.612)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M168.4,124.937v3.46l-2.076-.26V124.47",
    transform: "translate(-86.35 -70.695)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M174.47,125.049l13.305-1.929v11.748l-13.305,1.921Z",
    transform: "translate(-87.449 -70.513)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M160.67,122.081V110.74l6.964.649,4.974.285v11.7Z",
    transform: "translate(-85.588 -68.843)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M168.353,111.46v3.27L166,114.48v-3.21",
    transform: "translate(-86.307 -68.915)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M174.47,111.67v11.61l13.305-1.929V110Z",
    transform: "translate(-87.449 -68.743)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M160.67,110.455l11.938-1.825,13.305,1.185-13.305,1.574Z",
    transform: "translate(-85.588 -68.558)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M156.948,147.783V136.4L145.01,134.91v11.255Z",
    transform: "translate(-83.475 -72.104)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M152.736,135.87v3.5l-2.076-.225V135.61",
    transform: "translate(-84.237 -72.198)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M145.01,133.11V121.57l11.938,1.3V134.6Z",
    transform: "translate(-83.475 -70.304)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M152.736,122.647v3.469l-2.076-.268V122.18",
    transform: "translate(-84.237 -70.386)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M145.01,119.909V109.26l6.964.545,4.974.285v11.117Z",
    transform: "translate(-83.475 -68.643)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M152.693,109.89v3.374l-2.353-.251V110",
    transform: "translate(-84.194 -68.728)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M145.01,109.005l11.938-1.635,13.305,1.09-13.305,1.479Z",
    transform: "translate(-83.475 -68.389)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M171.122,108.162l14.75-1.462-11.618-1.28-15.113,1.67Z",
    transform: "translate(-85.381 -68.125)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_247",
    "data-name": "Line 247",
    x1: 4.031,
    y1: 0.424,
    transform: "translate(100.49 38.575)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_248",
    "data-name": "Line 248",
    y1: 0.882,
    x2: 4.715,
    transform: "translate(100.326 40.374)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    y1: 0.649,
    x2: 4.715,
    transform: "translate(100.326 51.967)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    y1: 0.64,
    x2: 4.715,
    transform: "translate(100.326 63.715)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M177.219,168.94v12.509l-15.529,2.37V170.861Z",
    transform: "translate(-85.725 -76.694)",
    fill: "#131924",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M148.13,167.4v12.25l11.731,3.962V170.653Z",
    transform: "translate(-83.896 -76.486)",
    fill: "#131924",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M175.322,168.43l-12.691-3.27-15,1.938,12.163,3.253Z",
    transform: "translate(-83.829 -76.184)",
    fill: "#131924",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M167.352,174.761h.078l4.81-.709a.562.562,0,0,0,.484-.554v-3.8H171.6v3.313l-3.685.545v-3.166H166.79v3.8a.562.562,0,0,0,.562.562Z",
    transform: "translate(-86.413 -76.797)",
    fill: "#f0f3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M110.47,178.587v2.258l24.283-7.457V171.45Z",
    transform: "translate(-78.816 -77.033)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M138.006,173.8v2.613L134.45,177.8l.009-2.82Z",
    transform: "translate(-82.051 -77.35)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M123.84,178.395l3.677-1.125v3.521l-3.677,1.523Z",
    transform: "translate(-80.62 -77.818)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M110.47,182.124v4.317l4.248-1.609-.009-3.9Z",
    transform: "translate(-78.816 -78.312)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M105.535,179.3,73.89,176.7v1.99l31.645,2.863Z",
    transform: "translate(-73.881 -77.741)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M104.75,181.97V185.8l4.948.787v-4.326Z",
    transform: "translate(-78.044 -78.452)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M92.222,180.716v4.031l-4.092-.874V180.5Z",
    transform: "translate(-75.802 -78.254)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M73.89,179.22v3.019l3.841.813v-3.5Z",
    transform: "translate(-73.881 -78.081)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M92.86,184.806l2.941-.787v-2.838l-2.941-.311Z",
    transform: "translate(-76.44 -78.304)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M78.33,183.131,81.4,182.2v-2.206l-3.071-.381Z",
    transform: "translate(-74.48 -78.134)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M107.96,177.476V164.5l-16.1-1.289v12.63Z",
    transform: "translate(-76.305 -75.921)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M122.858,160.89l-12.388,3.3v12.977l12.406-3.729Z",
    transform: "translate(-78.816 -75.608)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M102.1,164.024v4.594l-2.924-.346V163.79",
    transform: "translate(-77.293 -75.999)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M107.96,162.826V149.849l-16.1-1.289V161.2Z",
    transform: "translate(-76.305 -73.945)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M122.858,146.25l-12.388,3.287v12.977l12.406-3.729Z",
    transform: "translate(-78.816 -73.633)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M102.1,149.384v4.585l-2.924-.346V149.15",
    transform: "translate(-77.293 -74.025)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M73.88,174.756V161.33l15.555,1.626",
    transform: "translate(-73.88 -75.668)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M104.8,144.51l-12.942,3.5,16.1,1.289,12.388-3.287Z",
    transform: "translate(-76.305 -73.399)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M83.781,162.41v4.447l-2.751-.441V162.41",
    transform: "translate(-74.845 -75.813)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M73.88,160.386V146.96l15.555,1.626",
    transform: "translate(-73.88 -73.729)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M83.781,148.04v4.447l-2.751-.441V148.04",
    transform: "translate(-74.845 -73.875)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M73.88,144.866V131.44l15.555,1.626v13.184Z",
    transform: "translate(-73.88 -71.636)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M83.781,132.52v4.447l-2.751-.441V132.52",
    transform: "translate(-74.845 -71.781)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M104.8,142.54l-.069-12.63L91.86,132.86v13.184Z",
    transform: "translate(-76.305 -71.429)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M73.88,130.965l12.691-3.045,15.736,1.722-12.873,2.95Z",
    transform: "translate(-73.88 -71.161)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M136.61,156.81l.078,12.665-11.878,3.409V160.21Z",
    transform: "translate(-80.75 -75.058)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M136.61,142.41l.078,12.38-11.878,3.5V145.819Z",
    transform: "translate(-80.75 -73.115)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M136.61,128.01l.078,12.38-11.878,3.5V131.419Z",
    transform: "translate(-80.75 -71.173)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M122.372,131.675,106.74,129.91l.069,12.328,15.563,1.912Z",
    transform: "translate(-78.313 -71.429)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M116.759,131.043v3.46l-2.7-.156V130.74",
    transform: "translate(-79.3 -71.541)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M134.172,127.793l-15.3-1.393-12.129,3.037,14.854,1.678Z",
    transform: "translate(-78.313 -70.956)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M103.8,124.7l12.613,1.471-12.129,3.037L88.55,127.486Z",
    transform: "translate(-75.859 -70.726)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M123.23,178.57v3.919l-3.91-.787v-1.929Z",
    transform: "translate(-80.01 -77.993)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M134.014,177.98l-2.794-.8v-1.125l2.8-.891Z",
    transform: "translate(-81.615 -77.533)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M161.69,185.128v-14.3l17.224-2.128",
    transform: "translate(-85.725 -76.662)",
    fill: "none",
    stroke: "#f0f3f5",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    x1: 13.703,
    y1: 3.573,
    transform: "translate(62.261 90.602)",
    fill: "none",
    stroke: "#f0f3f5",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcl);
export default __webpack_public_path__ + "static/media/lcl.3e8e4acd5fae845485e89bc783c918ae.svg";
export { ForwardRef as ReactComponent };